import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { Routes as AppRoutes } from "../../constants/RouteConstants";
import FrontLoader from "./FrontLoader";
import {
  consumeStripeCheckoutSessionId,
  getStripeSessionIdFromSearch,
} from "../../utils/stripeCheckout";
import failedImg from "../../Assets/images/cancel-svgrepo-com.svg";

function PaymentFailed() {
  const PaymentStatus = useMakeRequest();
  const navigate = useNavigate();
  const submittedRef = useRef(false);

  useEffect(() => {
    if (submittedRef.current) return;

    const paymentId =
      consumeStripeCheckoutSessionId() ||
      getStripeSessionIdFromSearch(window.location.search);

    if (!paymentId) return;

    submittedRef.current = true;
    const payload = {
      type: "web",
      payment_type: 0,
      paymeny_status: "failed",
      payment_id: paymentId,
    };
    PaymentStatus.makeRequest({
      payload,
      url: ApiConstants?.OrderStatus,
      toastStatus: false,
    });
  }, []);

  return (
    <>
      {PaymentStatus.loading ? <FrontLoader /> : null}
      <div
        className="modal fade com-modal short-modal success-modal text-center show"
        id="paymentFailedModal"
        aria-labelledby="paymentFailedModalLabel"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body py-0">
              <img
                className="success-img"
                src={failedImg}
                alt=""
                style={{ width: "100px" }}
              />
              <div className="success-heading">
                {LanguageConstants?.Payment_Failed ?? "Payment Declined"}
              </div>
              <div className="px-5 mb-4">
                <p>{LanguageConstants?.Payment_Failed1}</p>
                <p>{LanguageConstants?.Payment_Failed2}</p>
              </div>
            </div>
            <div className="modal-footer d-flex flex-column gap-2">
              <button
                type="button"
                className="round-btn m-0 w-100"
                onClick={() => navigate(AppRoutes.Order)}
              >
                {LanguageConstants?.MYORDER ?? "My Orders"}
              </button>
              <button
                type="button"
                className="round-btn m-0 w-100"
                onClick={() => navigate(AppRoutes.Home)}
              >
                {LanguageConstants?.GO_TO_HOME}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentFailed;
